export default "__VITE_ASSET__BfGBdeVg__"